import { PALETTE } from "./tokens";

/* Lightweight CSS+SVG hero backdrop. Amber dotted lattice +
   slow drifting glow. Respects prefers-reduced-motion via the
   page-level @media rule on .cb-drift. */
export const AmbientBackdrop = () => (
  <div aria-hidden style={{
    position: "absolute", inset: 0, overflow: "hidden",
    pointerEvents: "none", zIndex: 0,
  }}>
    {/* Dotted lattice */}
    <div style={{
      position: "absolute", inset: 0,
      backgroundImage: `radial-gradient(${PALETTE.amber}26 1px, transparent 1px)`,
      backgroundSize: "22px 22px",
      maskImage: "radial-gradient(ellipse at 30% 30%, black 0%, transparent 70%)",
      WebkitMaskImage: "radial-gradient(ellipse at 30% 30%, black 0%, transparent 70%)",
      opacity: 0.55,
    }} />
    {/* Drifting glow */}
    <div className="cb-drift" style={{
      position: "absolute", top: "-15%", left: "10%",
      width: 560, height: 560, borderRadius: "50%",
      background: `radial-gradient(circle, ${PALETTE.amberSoft}33 0%, transparent 60%)`,
      filter: "blur(50px)",
    }} />
    <div className="cb-drift cb-drift-2" style={{
      position: "absolute", bottom: "-10%", right: "5%",
      width: 420, height: 420, borderRadius: "50%",
      background: `radial-gradient(circle, ${PALETTE.amber}22 0%, transparent 60%)`,
      filter: "blur(60px)",
    }} />
    {/* Faint horizontal scan line */}
    <div style={{
      position: "absolute", left: 0, right: 0, top: "62%",
      height: 1, background: `linear-gradient(90deg, transparent, ${PALETTE.amber}55, transparent)`,
      opacity: 0.4,
    }} />
  </div>
);